import React, { useEffect, useRef, useState } from "react"
import MetaTags from "react-meta-tags"
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import Modal from "react-bootstrap/Modal"
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Label,
  Input,
  ModalBody,
  Table,
  Spinner
} from "reactstrap"
import Select from "react-select"
import { useSelector, useDispatch } from "react-redux"
import PropTypes from "prop-types"
import { isEmpty } from "lodash"
import moment from "moment"
//Data Table packeages
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
  PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"
import { ReactSearchAutocomplete } from "react-search-autocomplete"

import ToolkitProvider from "react-bootstrap-table2-toolkit"

import "./styles.scss"
import ReactQuill from "react-quill"
import "react-quill/dist/quill.snow.css"


//components
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import * as ticketsReceivedAction from "../../../store/aW5wcm9ncmVzc1JlY2VpdmVk/actions"
import ButtonSpinner from "../../../components/ButtonSpinner"
import * as ticketQueryAction from "../../../store/cmFpc2VUaWNrZXQ/actions"
import { toast } from "react-toastify"
import SimpleReactValidator from "simple-react-validator"
import api from "helpers/Api"


const InprogressReceived = (props) => {
  const { dispatch, searchBtnStyle, location } = props
  const title = "Inprogress Received"



  const specificDispatch = useDispatch()
  const empId = localStorage.getItem("empId")
  useEffect(() => {
    dispatch(ticketsReceivedAction.loadRecordsMetaData())
    dispatch(
      ticketsReceivedAction.loadTicketQuery({
        page:1,
        limit:50,
        reportingTo: empId,
        status: "active",
        mode: "inprogress",
      })
    )
    dispatch(ticketQueryAction.loadPriorityRecordsMetaData())
    // dispatch(ticketQueryAction.loadSubLabelDetails({ status: "active" }))
    dispatch(
      ticketQueryAction.loadEmployeeLabels({
        status: "active",
        employeeId: empId,
      })
    )
  }, [])

  const ticketUpdate = useSelector((state) => state.inprogressReceived)
  const { recordsMetaData = {}, ticket_details = [] } = ticketUpdate

  const sessionUpdate = useSelector((specificstate) => specificstate.session)

  const { user = [] } = sessionUpdate
  const [pageCount, setPageCount] = useState(false)
  const [pageChange, setPageChange] = useState(false)
  const [searchFilter, setSearchFilter] = useState(false)
  const [searchInput, setSearchInput] = useState([])
  const [downloadLoading, setDownloadLoading] = useState(false)
  const [loading, setLoading] = useState(false)
  //Search value
  const [searchValueList, setSearchValueList] = useState({})
  const searchFilterValue =
    !isEmpty(searchValueList) && isEmpty(searchInput)
      ? searchValueList
      : isEmpty(searchValueList) && isEmpty(searchInput)
        ? {
          page: pageChange ? pageCount : 1,
          limit: 50,
          reportingTo: empId,
          status: "active",
          mode: "inprogress",
        }
        : {
          page: pageChange ? pageCount : 1,
          limit: 50,
          reportingTo: empId,
          status: "active",
          mode: "inprogress",
          searchFilter: searchInput,

        }

  //Validation

  const simpleValidator = useRef(new SimpleReactValidator())
  const [, forceUpdate] = useState()
  //Date format
  const dateSetting =
    !isEmpty(user) && user.setting && user.setting.dateFormate
      ? user.setting.dateFormate.toUpperCase()
      : []
  const empName = !isEmpty(user) && user.name ? user.name : ""

  const dateFormate = !isEmpty(dateSetting) && dateSetting ? dateSetting : ""

  const ticketStoreUpdate = useSelector((state) => state.raiseTicket)

  const {

    priorityMetaData = {},
  } = ticketStoreUpdate
  //Offer initial state
  const [ticketData, setTicketData] = useState({
    title: "",
    fromDate: "",
    toDate: "",
  })


  //Handle change

  const handleChange = async (e) => {
    setTicketData({ ...ticketData, [e.target.name]: e.target.value })
  }
  //query id
  const [queryId, setQueryId] = useState("")
  const [activitiesData, setActivitiesData] = useState([])

  useEffect(() => {
    let interval
    if (!isEmpty(queryId)) {
      interval = setInterval(() => {
        api
          .post(`/get-ticket-activities`, { queryId: queryId })
          .then((response) => {
            setActivitiesData(response.data.data)
            response.data
          })
          .catch((error) => Promise.reject(error))

      }, 7000)
    }

    return () => {
      if (interval) {
        clearInterval(interval)
        setActivitiesData([])
      }
    }
  }, [queryId])
  //dropdown initial state

  const [employeeLabel, setEmployeeLabel] = useState([])
  // const [employeeSubLabel, setEmployeeSubLabel] = useState([])

  const [senderMember, setSenderMember] = useState([])
  const [ccEmployee, setCcEmployee] = useState([])
  const [ticketStatus, setTicketStatus] = useState([])
  // const [testSimpleModal, setTestSimpleModal] = useState(false)

  //On Change
  const handleEmployeeLabel = (e) => {
    setEmployeeLabel(e)
  }

  const fuseOptions = {
    keys: ["empCode", "label"],
  }

  //reset functionalities

  const [resetCcEmployee, setResetCcEmployee] = useState(false)
  const [resetSenderMember, setResetSenderMember] = useState(false)
  const resetForm = () => {
    setSearchInput("")
    setSearchValueList({})
    setCcEmployee([])
    setSenderMember([])
    setResetCcEmployee(true)
    setResetSenderMember(true)
    setEmployeeLabel([])
    setTicketStatus([])
    setTimeout(() => {
      setResetCcEmployee(false)
      setResetSenderMember(false)
    }, 500)
    setTicketData({
      fromDate: "",
      toDate: "",
    })
    dispatch(
      ticketsReceivedAction.loadTicketQuery({
        page:1,
        limit:50,
        reportingTo: empId,
        mode: "inprogress",
        status: "active",
      })
    )
  }

  const [editableText, setEditableText] = useState("")

  const [ticketDescription, setTicketDescription] = useState("")
 
 
 



  const modulesOne = {
    toolbar: {
      container: [
        [{ header: [1, 2, false] }],
        ["bold", "italic", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["link", "image", "video", "mic", "pdf"], // Custom mic button with Bootstrap icon class
        ["clean"],
      ],

    },
  }

  const formatsOne = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "list",
    "bullet",
    "link",
    "image",
    "video",
    "mic",
    "blockquote",
    "color",
    "image",
    "background",
    "align",
    "size",
    "font",
  ]


  //button spinner state
  const [btnLoader, setBtnLoader] = useState(false)
  const [deleteModal, setDeleteModal] = useState(false)
  const [ticketQueryId, setTicketQueryId] = useState("")

  //Apply filter submit

  const applyFilter = (e) => {
    e.preventDefault()
    var searchSenderMember =
      senderMember && senderMember ? senderMember.value : ""
    var searchEmployeeCC = ccEmployee && ccEmployee ? ccEmployee.value : ""
    var searchEmployeeLabel =
      employeeLabel && employeeLabel ? employeeLabel.value : ""

    var searchFromDate =
      ticketData && ticketData.fromDate
        ? moment(ticketData.fromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      ticketData && ticketData.toDate
        ? moment(ticketData.toDate).format("YYYY-MM-DD")
        : ""
    var searchStatus = !isEmpty(ticketStatus)
      ? ticketStatus.processStatusId
      : ""
    var searchValue = {}
    searchValue.reportingTo = empId
    searchValue.mode = "inprogress"
    searchValue.status = "active"
    searchValue.page = pageChange ? pageCount : 1
    searchValue.limit = sizePerPage ? sizePerPage : 50
    if (searchSenderMember) {
      searchValue.querySentId = searchSenderMember
    }
    if (searchEmployeeCC) {
      searchValue.reportingBc = searchEmployeeCC
    }
    if (searchEmployeeLabel) {
      searchValue.labelId = searchEmployeeLabel
    }
    if (searchStatus) {
      searchValue.queryStatus = searchStatus
    }
    if (searchFromDate) {
      searchValue.fromDate = searchFromDate
    }
    if (searchToDate) {
      searchValue.toDate = searchToDate
    }

    specificDispatch(ticketsReceivedAction.loadTicketQuery(searchValue))
    setBtnLoader(true)
    setTimeout(() => {
      setBtnLoader(false)
    }, 2000)
  }

  let slNo = 0
  const offerReportTable =
    !isEmpty(ticket_details) && ticket_details.data &&
      ticket_details.data.length > 0
      ? ticket_details.data.map((data, index) => {
        slNo = slNo + 1
        const reportingBc =
          !isEmpty(data.reportingBc) && data.reportingBc.length > 0
            ? data.reportingBc.map((data) => data.name)
            : []
        const reportingBcName =
          !isEmpty(reportingBc) && reportingBc.length > 0
            ? reportingBc.join(",")
            : "--"

        const reportingTo =
          !isEmpty(data.reportingTo) && data.reportingTo.length > 0
            ? data.reportingTo.map((data) => data.name)
            : []
        const reportingToName =
          !isEmpty(reportingTo) && reportingTo.length > 0
            ? reportingTo.join(",")
            : "--"
        const attachments =
          !isEmpty(data.attachments) && data.attachments.length > 0
            ? data.attachments.map((data) => {
              return {
                attachments: data,
              }
            })
            : []
        const attachmentsData =
          !isEmpty(data.attachments) && data.attachments.length > 0
            ? data.attachments.map((data) => data)
            : "--"
        const processStatusName =
          !isEmpty(priorityMetaData) &&
            !isEmpty(priorityMetaData.processStatusOptions) &&
            priorityMetaData.processStatusOptions &&
            priorityMetaData.processStatusOptions.length > 0
            ? priorityMetaData.processStatusOptions.find(
              (_) => _.processStatusId === data.queryStatus
            )
            : ""
        const createdAt = data.createdAt
          ? moment(data.createdAt).format(`${dateFormate} hh:mm A`)
          : "--"
        const modifiedDetails =
          !isEmpty(data.queryChatDetail) && data.queryChatDetail.length > 0
            ? data.queryChatDetail[data.queryChatDetail.length - 1].updatedAt
            : []

        const modifiedDate =
          !isEmpty(modifiedDetails) && modifiedDetails.length > 0
            ? moment(modifiedDetails).format("DD-MM-YYYY hh:mm A")
            : "--"

        return {
          _id: data._id,
          sNo: slNo,
          title: data.title,
          queryStatus: data.queryStatus,
          description: data.description ? data.description : "",
          // ?
          //   result : "",
          action: (
            <Button
              type="submit"
              className="mx-2 btn btn-danger"
              onClick={() => {
                setTicketQueryId(data._id)
                setDeleteModal(true)
              }}
            >
              <i className="bx bx-trash icon-btn font-size-12"></i>
            </Button>
          ),
          colorCode: !isEmpty(processStatusName)
            ? processStatusName.colorCode
            : "",
          subject: !isEmpty(data.subject) ? data.subject : "--",
          closeTicket: data.closeTicket,
          priority: !isEmpty(data.priority) ? data.priority : "--",
          employeeLabel: !isEmpty(data.employeeLabelName)
            ? data.employeeLabelName
            : "",
          employeeLabelId: !isEmpty(data.employeeLabelId)
            ? data.employeeLabel
            : "--",
          labelId: !isEmpty(data.labelId) ? data.labelId : "--",
          labelName: !isEmpty(data.labelName)
            ? data.labelName.map((l) => l).join(",") : "",

          modifiedDate: modifiedDate,
          reportingBc: reportingBcName,
          status: data.status,
          queryStatusName: data.queryStatusName,
          updatedOn: !isEmpty(data.updatedOn)
            ? moment(data.updatedOn).format(`${dateFormate} hh:mm A`)
            : "--",
          updatedByName: data.updatedByName,
          activities: data.activities,
          ticket: data.ticket,
          queryChatDetails: data.queryChatDetail,
          attachmentsData: attachmentsData,
          reportingTo: reportingToName,
          attachments: attachments,
          createdDate: createdAt,
          sender: !isEmpty(data.insertedName) ? data.insertedName : "--",
          ticketNo: !isEmpty(data.refNo) ? data.refNo : "--",
          key: index,
        }
      })
      : []

  //Modal section
  const [testModal, setTestModal] = useState(false)
  const [attachmentModal, setAttachmentModal] = useState(false)
  const [attachmentDetails, setAttachmentDetails] = useState("")




  //columns for data table
  const initialColumns = [
    {
      dataField: "sNo",
      text: "S.No",
      hidden: false,
    },

    {
      dataField: "ticketNo",
      text: "Ticket No",
      sort: true,
      hidden: false,
      headerStyle: {
        minWidth: "125px",
      },
      style: {
        color: "#e40d8c",
        textTransform: "uppercase",
      },
    },
    {
      dataField: "sender",
      text: "Sender",
      sort: true,
      hidden: false,
      headerStyle: {
        minWidth: "125px",
      },
    },
    {
      dataField: "title",
      text: "Subject",
      sort: true,
      hidden: false,
      headerStyle: {
        minWidth: "165px",
      },
    },

    {
      dataField: "attachmentsData",
      text: "Attachment",
      sort: true,
      hidden: false,
      formatter: (cellContent, row) => {
    
        return (
          <button
            className="btn btn-warning"
            onClick={() => {
              setAttachmentDetails(row.attachments)
              setAttachmentModal(true)
            }}
            style={{
              padding: "3px 5px",
            }}
          >
            Attachment
          </button>
        )
      },
      headerStyle: {
        minWidth: "135px",
      },
    },

    {
      dataField: "reportingTo",
      text: "To Members",
      headerStyle: {
        minWidth: "170px",
      },
      hidden: true,
      csvExport: false,
      // expandRow: true,
    },

    {
      dataField: "labelName",
      text: "Label",
      sort: true,
      formatter: (cellContent, row) => {
        return (
          <>
            {row.labelName ? (
              <button
                style={{
                  backgroundColor: "#34c28f",
                  color: "white",
                  fontSize: "12px",
                  padding: "4px",
                  border: "none",
                  borderRadius: "4px",
                }}
              >
                {row.labelName}
              </button>
            ) : (
              "--"
            )}
          </>
        )
      },
      hidden: false,
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "employeeLabel",
      text: "Employee Label",
      sort: true,
      hidden: true,
      formatter: (cellContent, row) => {
        return (
          <>
            {row.employeeLabel ? (
              <button
                style={{
                  backgroundColor: "#34c28f",
                  color: "white",
                  fontSize: "12px",
                  padding: "4px",
                  border: "none",
                  borderRadius: "4px",
                }}
              >
                {row.employeeLabel}
              </button>
            ) : (
              "--"
            )}
          </>
        )
      },
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "reportingBc",
      text: "CC Members",
      sort: true,
      hidden: false,
      headerStyle: {
        minWidth: "175px",
      },
    },
    {
      dataField: "priority",
      text: "Priority",
      sort: true,
      hidden: true,
      headerStyle: {
        minWidth: "125px",
      },
    },


    {
      dataField: "createdDate",
      text: "Ticket Date",
      sort: true,
      hidden: false,
      headerStyle: {
        minWidth: "164px",
      },
    },
    {
      dataField: "queryStatus",
      text: "Ticket Status",
      sort: true,
      hidden: false,
      formatter: (cellContent, row) => {
        return (
          <button
            style={{
              background: row.colorCode,
              border: "none",
              cursor: "pointer",
              color: "white",
              padding: "4px 6px",
              borderRadius: "4px",
            }}
          // onClick={setTestSimpleModal(true)}
          >
            {row.queryStatusName && row.status != 2
              ? row.queryStatusName
              : row.status == 2
                ? "Archieved"
                : row.queryStatusName}
          </button>
        )
      },
      headerStyle: {
        minWidth: "148px",
      },
    },
    {
      dataField: "ticket",
      text: "Ticket Reply",
      sort: false,
      csvExport: false,
      hidden: false,
      formatter: (cellContent, row) => {
        return (
          <div>
            <Button
              onClick={() => {
                setEditableText(row)
                setTicketDescription("")
               
                setTestModal(true)
                setQueryId(row._id)

                const activityDetails = {
                  queryId: row._id,
                }
                // setActivityModal(true)
                setTimeout(() => {
                  api
                    .post(`/get-ticket-activities`, activityDetails)
                    .then((response) => {
                      setActivitiesData(response.data.data)
                      response.data
                    })
                    .catch((error) => Promise.reject(error))

                }, 500)
              }}
              style={{ padding: "4px", fontSize: "12px" }}
              className="btn btn-info"
            >
              {"Reply"}
            </Button>
          </div>
        )
      },
      headerStyle: {
        minWidth: "125px",
      },
    },
    {
      dataField: "updatedOn",
      text: "Modified Date",
      headerStyle: {
        minWidth: "150px",
      },
      hidden: false,
      csvExport: true,

      // expandRow: true,
    },
    {
      dataField: "updatedByName",
      text: "Modified By",
      headerStyle: {
        minWidth: "150px",
      },
      hidden: false,
      csvExport: true,
      // expandRow: true,
    },
  ]

  //Columns section
  const [columns, setColumns] = useState(initialColumns)
  const [columnModal, setColumnModal] = useState(false)
  const [oddColumnData, setOddColumnData] = useState([])
  const [evenColumnData, setEvenColumnData] = useState([])
  useEffect(() => {
    if (columns && columns.length > 0) {
      var array = columns
      var evenColumns = []
      var oddColumns = []

      for (var i = 0; i < array.length; i++) {
        if (i % 2 === 0) {
          oddColumns.push(array[i])
        } else {
          evenColumns.push(array[i])
        }
      }

      setOddColumnData(oddColumns)
      setEvenColumnData(evenColumns)
    }
  }, [columns])

  const selectColumn = columns
    .filter((column) => column.hidden === false)
    .map((column) => column.dataField)

  const [selectedColumns, setSelectedColumns] = useState(selectColumn)
  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target

    let updatedSelectedColumns
    if (checked) {
      updatedSelectedColumns = [...selectedColumns, value]
    } else {
      updatedSelectedColumns = selectedColumns.filter(
        (column) => column !== value
      )
    }

    setSelectedColumns(updatedSelectedColumns)
  }

  //  "Select All" checkbox
  const handleSelectAllChange = (e) => {
    const { checked } = e.target
    if (checked) {
      const allColumns = columns.map((column) => column.dataField)
      setSelectedColumns(allColumns)
    } else {
      const restoredColumns = initialColumns
        .filter((column) => !column.hidden)
        .map((column) => column.dataField)
      setSelectedColumns(restoredColumns)
    }
  }

  const handleSaveColumns = () => {
    setColumnModal(false)

    const updatedColumns = columns.map((column) => {
      const isColumnSelected = selectedColumns.includes(column.dataField)
      return { ...column, hidden: !isColumnSelected }
    })

    setColumns(updatedColumns)
    // default columns
    const defaultColumns = initialColumns.filter((column) => !column.hidden)
    const selectedNonDefaultColumns = selectedColumns.filter(
      (column) =>
        !defaultColumns.some(
          (defaultColumn) => defaultColumn.dataField === column
        )
    )

    if (selectedNonDefaultColumns.length > 0) {
      toast.success("New Columns added successfully!", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })
    }
  }

  const handleRestoreToDefault = () => {
    const restoreColumns = initialColumns
      .filter((column) => !column.hidden)
      .map((column) => column.dataField)

    setSelectedColumns(restoreColumns)
  }


  //Delete
  const deleteTicketSent = () => {
    const deleteTicket = {
      queryId: [ticketQueryId],
      status: 2,
    }
    dispatch(ticketsReceivedAction.deleteTicketQuery(deleteTicket))
    setTimeout(() => {
      dispatch(
        ticketsReceivedAction.loadTicketQuery(searchFilterValue)
      )
      setDeleteModal(false)
      toast.success("Records Deleted Successfully", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })
    }, 1000)
  }
  //export excel
  const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType })

    const a = document.createElement("a")
    a.download = fileName
    a.href = window.URL.createObjectURL(blob)
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    })
    a.dispatchEvent(clickEvt)
    a.remove()
  }

  const exportToCsv = () => {
    var searchSenderMember =
      senderMember && senderMember ? senderMember.value : ""
    var searchEmployeeCC = ccEmployee && ccEmployee ? ccEmployee.value : ""
    var searchEmployeeLabel =
      employeeLabel && employeeLabel ? employeeLabel.value : ""

    var searchFromDate =
      ticketData && ticketData.fromDate
        ? moment(ticketData.fromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      ticketData && ticketData.toDate
        ? moment(ticketData.toDate).format("YYYY-MM-DD")
        : ""
    var searchStatus = !isEmpty(ticketStatus)
      ? ticketStatus.processStatusId
      : ""
    var searchValue = {}
    searchValue.reportingTo = empId
    searchValue.mode = "inprogress"
    searchValue.status = "active"
    if (searchSenderMember) {
      searchValue.querySentId = searchSenderMember
    }
    if (searchEmployeeCC) {
      searchValue.reportingBc = searchEmployeeCC
    }
    if (searchEmployeeLabel) {
      searchValue.labelId = searchEmployeeLabel
    }
    if (searchStatus) {
      searchValue.queryStatus = searchStatus
    }
    if (searchFromDate) {
      searchValue.fromDate = searchFromDate
    }
    if (searchToDate) {
      searchValue.toDate = searchToDate
    }

    setPageLoad(!pageLoad)

    setDownloadLoading(true)
    api
      .post(`/get_all_query_excel_export`, searchValue)
      .then((response) => {
        const exportDataTable = !isEmpty(response.data.data)
          ? response.data.data.map((data, index) => {
           

            const reportingBc =
          !isEmpty(data.reportingBc) && data.reportingBc.length > 0
            ? data.reportingBc.map((data) => data.name)
            : []
        const reportingBcName =
          !isEmpty(reportingBc) && reportingBc.length > 0
            ? reportingBc.join(",")
            : "--"

        const reportingTo =
          !isEmpty(data.reportingTo) && data.reportingTo.length > 0
            ? data.reportingTo.map((data) => data.name)
            : []
        const reportingToName =
          !isEmpty(reportingTo) && reportingTo.length > 0
            ? reportingTo.join(",")
            : "--"
      
      
      
        const createdAt = data.createdAt
          ? moment(data.createdAt).format(`${dateFormate} hh:mm A`)
          : "--"
        const modifiedDetails =
          !isEmpty(data.queryChatDetail) && data.queryChatDetail.length > 0
            ? data.queryChatDetail[data.queryChatDetail.length - 1].updatedAt
            : []

        const modifiedDate =
          !isEmpty(modifiedDetails) && modifiedDetails.length > 0
            ? moment(modifiedDetails).format("DD-MM-YYYY hh:mm A")
            : "--"

        return {
          _id: data._id,
          sNo: index + 1,
          title: data.title,
          queryStatus: data.queryStatus,
          description: data.description ? data.description : "",
         
          subject: !isEmpty(data.subject) ? data.subject : "--",
          closeTicket: data.closeTicket,
          priority: !isEmpty(data.priority) ? data.priority : "--",
          employeeLabel: !isEmpty(data.employeeLabelName)
            ? data.employeeLabelName
            : "",
          employeeLabelId: !isEmpty(data.employeeLabelId)
            ? data.employeeLabel
            : "--",
          labelId: !isEmpty(data.labelId) ? data.labelId : "--",
          labelName: !isEmpty(data.labelName)
            ? data.labelName.map((l) => l).join(",") : "",

          modifiedDate: modifiedDate,
          reportingBc: reportingBcName,
          status: data.status,
          queryStatusName: data.queryStatusName,
          updatedOn: !isEmpty(data.updatedOn)
            ? moment(data.updatedOn).format(`${dateFormate} hh:mm A`)
            : "--",
          updatedByName: data.updatedByName,
          activities: data.activities,
          ticket: data.ticket,
          queryChatDetails: data.queryChatDetail,
          reportingTo: reportingToName,
          createdDate: createdAt,
          sender: !isEmpty(data.insertedName) ? data.insertedName : "--",
          ticketNo: !isEmpty(data.refNo) ? data.refNo : "--",
          key: index,
        }
          })
          : []
        setTimeout(() => {
          let headerData = [
            "SNo,Ticket No, Sender, Subject,Label, CC Members,Ticket Date,Ticket Status,Modified Date, Modified By",
          ]

          let usersCsv =
            !isEmpty(exportDataTable) &&
            exportDataTable.reduce((acc, user) => {
              const {
                sNo,
                ticketNo,
                sender,
                subject,
                label,
                reportingBc,
                createdDate,
                queryStatusName,
                updatedOn,
                updatedByName
              } = user
              acc.push([
                sNo,
                ticketNo,
                sender,
                subject,
                label,
                reportingBc,
                createdDate,
                queryStatusName,
                updatedOn,
                updatedByName
              ])

              return acc
            }, [])

          downloadFile({
            data: [...headerData, ...usersCsv].join("\n"),
            fileName: "InProgressReceived.csv",
            fileType: "text/csv",
          })
          setDownloadLoading(false)
        }, 2500)
        return response.data
      })
      .catch((error) => Promise.reject(error))
  }
  const handleClick = (e) => {
    e.preventDefault()
    setSearchFilter(true)

    dispatch(
      ticketsReceivedAction.loadTicketQuery({

        searchFilter: searchInput,
        page: pageChange ? pageCount : 1,
        limit: sizePerPage,
        reportingTo: empId,
        status: "active",
        mode: "inprogress",
      })
    )
    setTimeout(() => {
      setSearchFilter(false)
    }, 1200)
  }
  const RemotePagination = ({
    data,
    page,
    // sort,
    sizePerPage,
    onTableChange,
    totalSize,
  }) => (
    <div>
      <PaginationProvider
        pagination={paginationFactory({
          custom: true,
          page,
          // sort,
          sizePerPage,
          totalSize,
        })}
      >
        {({ paginationProps, paginationTableProps }) => (
          <div>
            <ToolkitProvider
              keyField="_id"
              data={data}
              columns={columns}
              search
              exportCSV
            >
              {() => (
                <div>
                  <Col md="12" xl="12" lg="12" sm="12" xs="12">
                    <Row className="d-flex flex-row">
                      <Col className="mb-3" md="4"></Col>
                      <Col
                        md="8"
                        style={{ marginBottom: "20px", marginTop: "-41px" }}
                      >
                        <div
                          style={{
                            float: "right",
                          }}
                        >
                          <Button
                            className="btn btn-info"
                            onClick={() => setColumnModal(true)}
                          >
                            Edit Columns
                          </Button>
                        </div>
                        <div
                          style={{
                            float: "right",
                            marginRight: "10px",
                          }}
                        >
                          <Button
                            className="btn btn-primary"
                            onClick={exportToCsv}
                            id="download"
                            style={{
                              backgroundColor: "#e40d8c",
                              color: "white",
                              border: "none",
                            }}
                          >
                            Download
                          </Button>
                        </div>
                      </Col>

                      <Col>
                        <BootstrapTable
                          remote
                          keyField="_id"
                          data={data}
                          id="ImportTable"
                          columns={columns}
                          responsive
                          noDataIndication={"No Data Found..."}
                          striped={true}
                          bordered={true}
                          onTableChange={onTableChange}
                          {...paginationTableProps}
                        />
                      </Col>
                    </Row>
                    <Row
                      style={{ marginTop: "5px" }}
                      className="align-items-md-center mt-30"
                    >
                      <Col className="inner-custom-pagination d-flex">
                        <div className="d-inline d-flex flex-row">
                          <SizePerPageDropdownStandalone {...paginationProps} />
                          <div
                            style={{
                              fontSize: "14px",
                              marginTop: "8px",
                              marginLeft: "4px",
                            }}
                          >
                            <PaginationTotalStandalone {...paginationProps} />
                          </div>
                        </div>
                        <div
                          className="text-md-right ms-auto"
                          style={{ zIndex: 0 }}
                        >
                          <PaginationListStandalone {...paginationProps} />
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </div>
              )}
            </ToolkitProvider>
          </div>
        )}
      </PaginationProvider>
    </div>
  )
  const [pageLoad, setPageLoad] = useState(false)
  const [state, setState] = useState({
    sizePerPage: 50,
    page: 1,
    totalSize: ticket_details.length,
    data:
      !isEmpty(ticket_details) && ticket_details.length > 0
        ? ticket_details.slice(0, 50)
        : [],
  })
  const { sizePerPage, page } = state

  //Table Change

  const handleTableChange = (
    type,
    { page, sortField, sortOrder, currentIndex, sizePerPage }
  ) => {
    setPageCount(page)
    setPageChange(true)
    setPageLoad(!pageLoad)
    let result =
      !isEmpty(ticket_details) && ticket_details.length > 0
        ? ticket_details
        : []
    if (
      !isEmpty(senderMember) ||
      !isEmpty(ccEmployee) ||
      !isEmpty(employeeLabel) ||
      !isEmpty(ticketData.fromDate) ||
      !isEmpty(ticketData.toDate) ||
      !isEmpty(ticketStatus)
    ) {
      var searchSenderMember =
        senderMember && senderMember ? senderMember.value : ""
      var searchEmployeeCC = ccEmployee && ccEmployee ? ccEmployee.value : ""
      var searchEmployeeLabel =
        employeeLabel && employeeLabel ? employeeLabel.value : ""

      var searchFromDate =
        ticketData && ticketData.fromDate
          ? moment(ticketData.fromDate).format("YYYY-MM-DD")
          : ""
      var searchToDate =
        ticketData && ticketData.toDate
          ? moment(ticketData.toDate).format("YYYY-MM-DD")
          : ""
      var searchStatus = !isEmpty(ticketStatus)
        ? ticketStatus.processStatusId
        : ""
      var searchValue = {}
      searchValue.reportingTo = empId
      searchValue.mode = "inprogress"
      searchValue.status = "active"
      searchValue.page = page
      searchValue.limit = sizePerPage ? sizePerPage : 50
      if (searchSenderMember) {
        searchValue.querySentId = searchSenderMember
      }
      if (searchEmployeeCC) {
        searchValue.reportingBc = searchEmployeeCC
      }
      if (searchEmployeeLabel) {
        searchValue.labelId = searchEmployeeLabel
      }
      if (searchStatus) {
        searchValue.queryStatus = searchStatus
      }
      if (searchFromDate) {
        searchValue.fromDate = searchFromDate
      }
      if (searchToDate) {
        searchValue.toDate = searchToDate
      }
      /////

      setPageLoad(!pageLoad)
      setLoading(true)
      specificDispatch(ticketsReceivedAction.loadTicketQuery(searchValue))
    } else {
      dispatch(
        ticketsReceivedAction.loadTicketQuery({
          page: page,
          limit: sizePerPage,
          reportingTo: empId,
          status: "active",
          mode: "inprogress",
        })
      )
      setLoading(true)
      setPageLoad(!pageLoad)
    }
    // setPageCount(page)
    setTimeout(() => {
      setLoading(false)
    }, 2000)
    if (sortOrder === "asc") {
      result = result.sort((a, b) => {
        if (a[sortField] > b[sortField]) {
          return 1
        } else if (b[sortField] > a[sortField]) {
          return -1
        }
        return 0
      })
    } else {
      result = result.sort((a, b) => {
        if (a[sortField] > b[sortField]) {
          return -1
        } else if (b[sortField] > a[sortField]) {
          return 1
        }
        return 0
      })
    }

    setState(() => ({
      page,
      data: result.slice(currentIndex, currentIndex + sizePerPage),
      totalSize: result.length,
      sizePerPage,
    }))
  }
  //Notifications data
  const notificationData =
    !isEmpty(location) &&
      location.state &&
      location.state.mode == "Notifications"
      ? location.state
      : ""
 

  const [notificationHide, setNotificationHide] = useState(false)
  //Add Query Chat

  const addQuery = (e) => {
    e.preventDefault()
    if (simpleValidator.current.allValid()) {
      const queryChat = {
        queryId:
          notificationData.mode == "Notifications" && notificationHide == false
            ? notificationData.ticketId
            : editableText._id,
        empId: empId,
        empName: empName,
        description: ticketDescription,

      }
    
      dispatch(ticketsReceivedAction.addQueryChat(queryChat))
      setTimeout(() => {
        dispatch(
          ticketsReceivedAction.loadTicketQuery(searchFilterValue)
        )
        const activityDetails = {
          queryId:
            notificationData.mode == "Notifications" &&
              notificationHide == false
              ? notificationData.ticketId
              : editableText._id,
        }
        setTimeout(() => {
          api
            .post(`/get-ticket-activities`, activityDetails)
            .then((response) => {
              setActivitiesData(response.data.data)
              response.data
            })
            .catch((error) => Promise.reject(error))
          // dispatch(activityAction.loadActivity(activityDetails))
        }, 500)
        // setFeedbackModal(false)
        toast.success("Query Chat Added Successfully", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        })
        setTicketDescription("")
      }, 1000)
    } else {
      simpleValidator.current.showMessages()
      forceUpdate(1)
    }
  }
  const handleTestModal = () => {
    setTestModal(false)
    setQueryId("")
    setNotificationHide(true)
  }

  useEffect(() => {
    if (
      notificationData &&
      notificationData.mode == "Notifications" &&
      !notificationHide
    ) {
      const activityDetails = {
        queryId: notificationData.ticketId,
      }
      setTestModal(true)
      setTicketDescription("")
      
      api
        .post(`/get-ticket-activities`, activityDetails)
        .then((response) => {
          setActivitiesData(response.data.data)
          response.data
        })
        .catch((error) => Promise.reject(error))
    }
  }, [])
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{title} | Zero Gravity CRM</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title={"Tickets"} breadcrumbItem={title} />

          {/*form start */}
          <Row>
            <Col xs={12}>
              <Card>
                <CardBody>
                  <form>
                    <Row>
                      <Col xl="3" lg="3" md="3" sm="3" xs="3" className="">
                        <Label
                          className="form-label"
                          htmlFor={"Event From Date"}
                        >
                          {"Sender Member"}
                        </Label>
                        <ReactSearchAutocomplete
                          key={resetSenderMember}
                          name="employee"
                          items={
                            recordsMetaData.employeeListOptions
                              ? recordsMetaData.employeeListOptions
                              : []
                          }
                          value={senderMember}
                          type="autoComplete"
                          resultStringKeyName="label"
                          showIcon={false}
                          onSelect={(e) => setSenderMember(e)}
                          onChange={(e) => setSenderMember(e.target.value)}
                          placeholder="Enter Sender Member"
                          fuseOptions={fuseOptions} // Search on both fields
                          styling={{
                            height: "34px",
                            border: "1px solid #ced4da",
                            borderRadius: "4px",
                            backgroundColor: "white",
                            boxShadow: "none",
                            hoverBackgroundColor: "#E40D8C",
                            color: "black",
                            fontSize: "12px",
                            fontFamily: "Courier",
                            iconColor: "green",
                            clearIconMargin: "3px 8px 0 0",
                            zIndex: 10,
                          }}
                        />
                      </Col>{" "}
                      <Col xl="3" lg="3" md="3" sm="3" xs="3" className="">
                        <Label
                          className="form-label"
                          htmlFor={"Event From Date"}
                        >
                          {"CC Members"}
                        </Label>
                        <ReactSearchAutocomplete
                          key={resetCcEmployee}
                          name="ccEmployee"
                          items={
                            recordsMetaData.employeeListOptions
                              ? recordsMetaData.employeeListOptions
                              : []
                          }
                          value={ccEmployee}
                          type="autoComplete"
                          resultStringKeyName="label"
                          showIcon={false}
                          onSelect={(e) => setCcEmployee(e)}
                          onChange={(e) => setCcEmployee(e.target.value)}
                          placeholder="Enter CC Members"
                          fuseOptions={fuseOptions} // Search on both fields
                          styling={{
                            height: "34px",
                            border: "1px solid #ced4da",
                            borderRadius: "4px",
                            backgroundColor: "white",
                            boxShadow: "none",
                            hoverBackgroundColor: "#E40D8C",
                            color: "black",
                            fontSize: "12px",
                            fontFamily: "Courier",
                            iconColor: "green",
                            clearIconMargin: "3px 8px 0 0",
                            zIndex: 10,
                          }}
                        />
                      </Col>{" "}
                      <Col lg="3" md="3" sm="12" xs="12">
                        <div className="d-flex justify-content-between">
                          <Label
                            className="form-label"
                            htmlFor={"Event From Date"}
                          >
                            {"Label"}
                          </Label>
                        </div>
                        <Select
                          type="text"
                          name="employeeLabel"
                          value={employeeLabel}
                          options={
                            recordsMetaData.labelOptions
                              ? recordsMetaData.labelOptions
                              : []
                          }
                          onChange={(e) => {
                            handleEmployeeLabel(e)
                          }}
                          placeholder="Select Label"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12">
                        <div className="d-flex justify-content-between">
                          <Label
                            className="form-label"
                            htmlFor={"Event From Date"}
                          >
                            {"From Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          placeholder="Select Date"
                          name="fromDate"
                          value={ticketData.fromDate}
                          max={ticketData.toDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className="form-label"
                            htmlFor={"Event To Date"}
                          >
                            {"To Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          placeholder="Select Date"
                          name="toDate"
                          value={ticketData.toDate}
                          min={ticketData.fromDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className="form-label"
                            htmlFor={"Ticket Status"}
                          >
                            {"Ticket Status"}
                          </Label>
                        </div>
                        <Select
                          type="text"
                          name="ticketStatus"
                          value={ticketStatus}
                          options={recordsMetaData.processStatusOptions}
                          onChange={(e) => setTicketStatus(e)}
                          placeholder="Select Ticket Status"
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="12" md="12" sm="12" xs="12" className="mt-3">
                        <div
                          className="filter-buttons"
                          style={{ float: "right" }}
                        >
                          <Button
                            type="button"
                            onClick={() => resetForm()}
                            className="btn btn-danger btn-label simple-form-Reset-btn"
                          >
                            <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                            Reset
                          </Button>
                          <Button
                            type="submit"
                            onClick={(e) => applyFilter(e)}
                            className="btn btn-success btn-label simple-form-applyfilter-btn mx-2"
                          >
                            <i className="bx bx-filter-alt label-icon"></i>
                            {btnLoader && btnLoader ? (
                              <ButtonSpinner />
                            ) : (
                              "Apply Filter"
                            )}{" "}
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </form>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col md="12" lg="12" xl="12">
              <Card>
                <CardBody>
                  <div
                    className="d-flex flex-row"
                    style={{ marginTop: "20px" }}
                  >
                    <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                      <form onSubmit={handleClick} className="d-flex flex-row">
                        <div style={searchBtnStyle || null}>
                          <Input
                            type="text"
                            name="searchInput"
                            value={searchInput}
                            onChange={(e) => setSearchInput(e.target.value)}
                            className="form-control"
                            placeholder="Search"
                            style={{ position: "relative" }}
                          />
                          <i
                            className="bx bx-search-alt"
                            style={{
                              position: "absolute",
                              top: "54px",
                              left: "41px",
                              fontSize: "13px",
                            }}
                          />
                        </div>
                        <button
                          className="btn btn-success mx-2"
                          type="submit"
                          style={{
                            background: searchFilter ? "#2ca67a" : "",
                            color: searchFilter ? "#ffffff" : "",
                          }}
                        >
                          <i className="fas fa-search"></i>
                        </button>
                      </form>
                    </div>
                  </div>{" "}
                  <RemotePagination
                    data={offerReportTable}
                    page={page}
                    sizePerPage={sizePerPage}
                    totalSize={
                      ticket_details.totalDataCount
                        ? ticket_details.totalDataCount
                        : 0
                    }
                    onTableChange={handleTableChange}
                  />

                </CardBody>
              </Card>
            </Col>
          </Row>
          {columnModal && (
            <Modal size="xl" show={columnModal}>
              <Modal.Header
                style={{
                  backgroundColor: "white",
                  color: "black",
                  fontSize: "16px",
                  fontWeight: "600",
                }}
              >
                Edit Columns
                <span>
                  <i
                    className="fa fa-times quote-close"
                    aria-hidden="true"
                    onClick={() => setColumnModal(false)}
                  ></i>
                </span>
              </Modal.Header>
              <Modal.Body>
                <Row>
                  <div>
                    <Input
                      type="checkbox"
                      checked={selectedColumns.length === columns.length}
                      onChange={(e) => handleSelectAllChange(e)}
                      style={{ width: "15px", height: "15px" }}
                    />
                    <Label style={{ fontSize: "16px", marginLeft: "10px" }}>
                      Select All
                    </Label>
                  </div>
                </Row>
                <Row>
                  <Col sm="12" md="6" lg="6" className="ml-4">
                    {oddColumnData.map((column) => (
                      <div key={column.dataField} className="d-flex flex-row">
                        <div className="form-check form-check-inline">
                          <Input
                            type="checkbox"
                            value={column.dataField}
                            checked={selectedColumns.includes(column.dataField)}
                            onChange={(e) => handleCheckboxChange(e)}
                            style={{ width: "15px", height: "15px" }}
                          />
                          <Label
                            style={{
                              fontSize: "16px",
                              marginLeft: "10px",
                            }}
                          >
                            {column.text}
                          </Label>
                        </div>
                      </div>
                    ))}
                  </Col>
                  <Col sm="12" md="6" lg="6">
                    {evenColumnData.map((column) => (
                      <div key={column.dataField} className="d-flex flex-row">
                        <div className="form-check form-check-inline">
                          <Input
                            type="checkbox"
                            value={column.dataField}
                            checked={selectedColumns.includes(column.dataField)}
                            onChange={(e) => handleCheckboxChange(e)}
                            style={{ width: "15px", height: "15px" }}
                          />
                          <Label
                            style={{
                              fontSize: "16px",
                              marginLeft: "10px",
                            }}
                          >
                            {column.text}
                          </Label>
                        </div>
                      </div>
                    ))}
                  </Col>
                </Row>
              </Modal.Body>

              <Modal.Footer>
                <p
                  className="text-decoration-underline text-info"
                  style={{ cursor: "pointer", fontSize: "16px" }}
                  onClick={handleRestoreToDefault}
                >
                  Restore To Default
                </p>
                <Button
                  variant="secondary"
                  className="btn btn-danger"
                  data-bs-dismiss="modal"
                  onClick={() => {
                    setColumnModal(false)
                    setSelectedColumns(selectColumn)
                  }}
                >
                  Close
                </Button>
                <Button
                  variant="primary"
                  className="btn btn-success"
                  onClick={() => handleSaveColumns()}
                >
                  Submit
                </Button>
              </Modal.Footer>
            </Modal>
          )}
          {deleteModal && (
            <Modal show={deleteModal} size="md" backdrop="static">
              <Modal.Header
                style={{
                  backgroundColor: "#E40D8C",
                  color: "white",
                  minHeight: "65px",
                  fontSize: "16px",
                  fontWeight: "600",
                }}
              >
                Delete Ticket Sent
              </Modal.Header>
              <Modal.Body>
                Are you sure, you want to Delete the Ticket Sent?
              </Modal.Body>
              <Modal.Footer>
                <div>
                  <Button
                    type="submit"
                    onClick={() => {
                      // deleteNightshift()
                      setDeleteModal(false)
                    }}
                    className="btn btn-danger buttons"
                  >
                    Cancel
                  </Button>
                  <Button
                    type="submit"
                    onClick={() => {
                      deleteTicketSent()
                    }}
                    className="btn btn-success buttons"
                    style={{ marginLeft: "15px" }}
                  >
                    Confirm
                  </Button>
                </div>
              </Modal.Footer>
            </Modal>
          )}
          {attachmentModal && (
            <Modal
              backdrop="static"
              show={attachmentModal}
              onHide={() => setAttachmentModal(false)}
              size="md"
            >
              <Modal.Header style={{ background: "#e40d8c", color: "white" }}>
                Attachments
              </Modal.Header>
              <Modal.Body>
                <Table>
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Attachment</th>
                    </tr>
                  </thead>
                  <tbody>
                    {!isEmpty(attachmentDetails) &&
                      attachmentDetails.length > 0 ? (
                      attachmentDetails.map((data, index) => {
                        const attachment = !isEmpty(data.attachments)
                          ? data.attachments
                          : ""
                        return (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>
                              <a
                                onClick={() =>
                                  window.open(attachment, "_blank")
                                }
                              >
                                <span
                                  style={{
                                    textDecoration: "underline",
                                    color: "#E40D8C",
                                  }}
                                >
                                  View
                                </span>
                              </a>
                            </td>
                          </tr>
                        )
                      })
                    ) : (
                      <tr>
                        <td></td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </Modal.Body>
              <Modal.Footer>
                <div className="d-flex flex-row">
                  <Button
                    className="btn btn-danger"
                    onClick={() => setAttachmentModal(false)}
                  >
                    Close
                  </Button>
                </div>
              </Modal.Footer>
            </Modal>
          )}

          {testModal == true ? (
            <Modal
              style={{
                width: "55%",
                marginLeft: "45%",
                height: "117%",
                marginTop: "-27px",
                overflowY: "scroll",
                overflowX: "hidden",
              }}
              // className="ticket-reply-modal"
              backdrop="static"
              show={testModal}
              size="md"
            // fullscreen={fullscreen}
            >
              <ModalBody
                style={{
                  background: "#f8f8fb",
                  overflowY: "auto",
                  width: "123.5%",
                  scrollbarWidth: "15px",
                }}
              >
                <div className="simple-right-bar-card">
                  <div
                  // className="modal-body"
                  >
                    <div className="mt-2">
                      <button
                        type="button"
                        onClick={() => handleTestModal()}
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                        style={{
                          fontSize: "12px",
                          marginTop: "-9px",
                          marginRight: "-3px",
                        }}
                      >
                        <span aria-hidden="true">&times</span>
                      </button>
                    </div>
                    <Row className="simple-form-row">
                      <Col xl="12" md="12" sm="12" lg="12">
                        <Card
                          style={{
                            marginTop: "10px",
                            height:
                              !isEmpty(activitiesData) &&
                                activitiesData.queryStatusHistory.length > 0
                                ? "550px"
                                : "350px",
                            padding: "10px",
                            // backgroundColor: "white",
                            borderRadius: "2px",
                            // padding: "2px 20px",
                            boxShadow: "#f9f9f9 1px 2px 2px 2px",
                          }}
                        >
                          <Row
                            style={{
                              overflowY: "auto",
                              scrollbarWidth: "thin",
                              overflowX: "hidden",
                            }}
                          >
                            <Col
                              xl={"12"}
                              lg={"12"}
                              md={"12"}
                              sm={"12"}
                              xs={"12"}
                              style={{
                                // marginLeft: "5px",
                                padding: "8px 15px",
                                position: "sticky",
                                top: 0,
                                bottom: 0,
                                background: "#eff2f7",
                                zIndex: 1000,
                              }}
                            >
                              <div style={{ width: "100%" }}>
                                <h5
                                  style={{
                                    textTransform: "uppercase",
                                    fontSize: "18px",
                                    color: "#3788d8",
                                    // background: "white",
                                  }}
                                  className="mx-3 modal-title"
                                  id="myModalLabel"
                                >
                                  {activitiesData.title}
                                </h5>
                              </div>
                            </Col>
                            <Col
                              xl={"12"}
                              lg={"12"}
                              md={"12"}
                              sm={"12"}
                              xs={"12"}
                              style={{
                                // marginLeft: "5px",
                                padding: "10px 15px",
                                // position: "sticky",
                                // top: 0,
                                // bottom: 0,
                                // background: "white",
                                // zIndex: 1000,
                              }}
                            >
                              <div
                                className="description-html-tag mx-3"
                                style={{
                                  width: "300px",
                                }}
                                dangerouslySetInnerHTML={{
                                  __html: !isEmpty(activitiesData.description)
                                    ? activitiesData.description.replace(
                                      /<img /g,
                                      `<img style="width: 280px; height: 150px "`
                                    )
                                    : "",
                                }}
                              ></div>
                            </Col>
                            <Col
                              xl={"12"}
                              lg={"12"}
                              md={"12"}
                              sm={"12"}
                              xs={"12"}
                              style={{
                                padding: "10px 24px",
                              }}
                            >
                              {!isEmpty(activitiesData) &&
                                activitiesData &&
                                activitiesData.queryStatusHistory.length > 0 &&
                                !isEmpty(
                                  activitiesData.queryStatusHistory[0]._id
                                ) ? (
                                activitiesData.queryStatusHistory.map(
                                  (data) => {
                                    const empName =
                                      !isEmpty(data) && data.empName
                                        ? data.empName.slice(0, 1)
                                        : "--"
                                    const createdDate = !isEmpty(data.createdOn)
                                      ? moment(data.createdOn).format(
                                        `${dateFormate} ${"hh:mm A"}`
                                      )
                                      : "--"

                                    return (
                                      <div
                                        className="d-flex flex-column mt-2"
                                        key={data._id}
                                      >
                                        <div
                                          className="d-flex flex-row"
                                          id="hoverSettings"
                                        >
                                          <div
                                            alt="Sample"
                                            className="member-show-details-img"
                                            id="PopoverClick"
                                            style={{
                                              position: "relative",
                                            }}
                                            type="button"
                                          >
                                            <p
                                              style={{
                                                position: "absolute",
                                                top: "7px",
                                                color: "#172b4d",
                                                left: "11px",
                                                fontSize: "14px",
                                                fontWeight: 700,
                                              }}
                                            >
                                              {empName}
                                            </p>
                                          </div>
                                          <div
                                            className="mx-2 d-flex flex-column"
                                            id="hoverSettings"
                                            style={{
                                              marginBottom: "-10px",
                                            }}
                                          >
                                            <div className="d-flex flex-row">
                                              <h5
                                                style={{
                                                  color: "#172b4d",
                                                  fontWeight: 600,
                                                }}
                                              >
                                                {!isEmpty(data.empName)
                                                  ? data.empName
                                                  : "User"}
                                              </h5>
                                              <h6
                                                style={{
                                                  color: "#172b4d",
                                                  fontWeight: 450,
                                                  marginLeft: "5px",
                                                  marginTop: "2px",
                                                }}
                                              >
                                                {createdDate}
                                              </h6>
                                            </div>

                                            <div
                                              className="description-html-tag"
                                              style={{
                                                width: "300px",
                                              }}
                                              dangerouslySetInnerHTML={{
                                                __html: !isEmpty(
                                                  data.description
                                                )
                                                  ? data.description.replace(
                                                    /<img /g,
                                                    `<img style="width: 280px; height: 150px "`
                                                  )
                                                  : "",
                                              }}
                                            // style={{}}
                                            ></div>
                                          </div>
                                        </div>
                                        <hr
                                          style={{
                                            width: "109%",
                                            marginLeft: "-22px",
                                          }}
                                        />
                                      </div>
                                    )
                                  }
                                )
                              ) : (
                                <div className="d-flex flex-row justify-content-between mt-2">
                                  <div className="d-flex flex-row">
                                    <h6>No Activities Updated Yet..</h6>
                                  </div>
                                </div>
                              )}
                            </Col>
                          </Row>
                        </Card>
                      </Col>
                    </Row>
                  </div>
                </div>
                <div
                  className="simple-right-bar-card mt-2"
                  style={{
                    padding: "0px 10px",
                  }}
                >
                  <Col
                    // xl="6"
                    // md="6"
                    // sm="6"
                    // lg="6"
                    style={{
                      backgroundColor: "white",
                      borderRadius: "2px",
                      padding: "2px 10px",
                      boxShadow: "#dddddd 1px 2px 2px 2px",
                    }}
                  >
                    <Row>
                      <Col xl="12" md="12" xs="12" sm="12">
                        <div
                          style={{
                            position: "relative",
                            marginTop: "20px",
                            marginBottom: !isEmpty(ticketDescription)
                              ? ""
                              : "40px",
                          }}
                        >
                          <ReactQuill
                            theme={"snow"}
                            modules={modulesOne}
                            value={ticketDescription}
                            onChange={setTicketDescription}
                            style={{
                              height: !isEmpty(ticketDescription)
                                ? "100%"
                                : "140px",
                              zIndex: 100,
                            }}
                            bounds={".rich-editor-style"}
                            formats={formatsOne}
                            className="ql-tooltip ql-editing"
                            placeholder="Add the detailed description..."
                          />
                          {simpleValidator.current.message(
                            "Description",
                            ticketDescription,
                            "required"
                          )}
                          {/* <div
                            style={{
                              position: "absolute",
                              top: "10px",
                              right: "10px",
                            }}
                            className="d-flex flex-row"
                          >
                            <i
                              className="fas fa-edit"
                              // onClick={(e) => addQuery(e)}
                              style={{
                                fontSize: "16px",
                                color: "black",
                                cursor: "pointer",
                                padding: "10px",
                              }}
                            ></i>
                             <i
                            className="fa fa-paper-plane"
                            onClick={(e) => addQuery(e)}
                            style={{
                              fontSize: "16px",
                              color: "black",
                              cursor: "pointer",
                              padding: "10px",
                            }}
                          ></i>
                          </div> */}
                        </div>
                      </Col>

                      <Col
                        style={{
                          marginBottom: "100px",
                        }}
                      >
                        <div
                          style={{
                            border: "1px solid #ccc",
                            boxShadow: "1px  #ccc",
                            display: "flex",
                            justifyContent: "flex-end",
                          }}
                        >
                          <i
                            className="fa fa-paper-plane"
                            onClick={(e) => addQuery(e)}
                            style={{
                              fontSize: "28px",
                              color: "black",
                              cursor: "pointer",
                              padding: "10px",
                            }}
                          ></i>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </div>
              </ModalBody>
            </Modal>
          ) : (
            ""
          )}
          {downloadLoading ? (
            <Modal
              show={downloadLoading}
              style={{ width: "7%", margin: "18% 50%" }}
            >
              <Modal.Body>
                <Spinner
                  as="span"
                  animation="grow"
                  size="lg"
                  role="status"
                  aria-hidden="true"
                  variant="success"
                  className="mx-2"
                  color="success"
                />
              </Modal.Body>
            </Modal>
          ) : (
            ""
          )}
          {loading ? (
            <Modal
              show={loading}
              style={{ width: "7%", margin: "18% 50%" }}
            >
              <Modal.Body>
                <Spinner
                  as="span"
                  animation="grow"
                  size="lg"
                  role="status"
                  aria-hidden="true"
                  variant="success"
                  className="mx-2"
                  color="success"
                />
              </Modal.Body>
            </Modal>
          ) : (
            ""
          )}
        </Container>
      </div>
    </React.Fragment>
  )
}

InprogressReceived.propTypes = {
  dispatch: PropTypes.func,
  searchProps: PropTypes.func,
  baseProps: PropTypes.any,
  searchBarStyle: PropTypes.any,
  csvProps: PropTypes.any,
  searchBtnStyle: PropTypes.any,
  disableMultiSelect: PropTypes.any,
  title: PropTypes.any,
  onSearch: PropTypes.func,
  onExport: PropTypes.func,
  pageClick: PropTypes.any,
  data: PropTypes.array.isRequired,
  page: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
  totalSize: PropTypes.number.isRequired,
  sizePerPage: PropTypes.number.isRequired,
  onTableChange: PropTypes.func.isRequired,
  location: PropTypes.any
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}
const mapStateToProps = () => ({
  //mapstate to props
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(InprogressReceived)
)
